package pl.nickers.match3.ecs

/**
 * Advances the level-1 tutorial ([TutorialComponent]) and clears it once it's done —
 * issue #110. Only acts when a [TutorialComponent] is present on the board entity
 * (attached by `GameViewModel` only while playing journey level 1) and the board is
 * settled ([GamePhase.INPUT]): checking mid-cascade would react to a transient board
 * state (cells briefly missing during a clear) rather than the real outcome.
 *
 * DESIGN CHOICE (issue #110 asks to pick one): input is NOT restricted to the hinted
 * swap during step 1. [RenderSystem] recomputes the hint from the live board on every
 * frame instead ([World.firstAvailableSwapHint]), so the highlight always tracks a
 * currently valid teaching swap even if the player makes a different, un-hinted move
 * first. This system only owns the *step* transition and the "no hint left, stop"
 * safety net, so the tutorial can never soft-lock the board.
 */
internal class TutorialSystem(private val pieceSet: PieceSet = PieceSetLoader.default()) : BaseSystem() {
    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.INPUT) return
        val boardId = world.boardEntityId() ?: return
        val tutorialMapper = world.mapper<TutorialComponent>()
        val tutorial = tutorialMapper[boardId] ?: return
        if (tutorial.step != TutorialStep.SWAP_HINT) return
        if (board.score > tutorial.startScore) {
            tutorial.step = TutorialStep.POINT_AT_GOALS
            return
        }
        if (world.firstAvailableSwapHint(board.width, board.height, pieceSet) == null) {
            // No teaching swap exists on the current board (e.g. an unlucky reshuffle) —
            // drop the tutorial rather than show a stale/invalid highlight forever.
            tutorialMapper.remove(boardId)
        }
    }
}
